@if (!isAdmin) {
  <div class="idf-selector cursor-pointer" (click)="openIdfSelector()">
    <div class="d-flex aic"><span>IDF:&nbsp;</span><span class="d-flex aic">{{ userService.getSelectedIdf() }}
      @if (idfs && idfs.length > 1) {
        <span class="material-symbols-outlined">arrow_drop_down</span>
      }
  </span>
    </div>
  </div>
}

@if (showInput) {
  <input placeholder="IDF" (change)="inputIdf($event)" class="idf-selector" id="nf-idf">
}
